import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: "The stakeholder's role or involvement in the project",
    name: 'Stakeholder Project Role',
    partialId: PartialId.Standard.create('stakeholder_project_role'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
